import axios from 'axios'
import { apiService } from '../api'

const ENDPOINTS = {
  CONFIG: '/configuration/trending',
  MARKET_TEMPLATES: '/configuration/template-markets',
}

class TrendingConfigurationService {
  constructor() {
    this.setHeaders();
  }

  setHeaders() {
    this.trendingAxiosClient = axios.create({
      headers: {
          'Authorization':  `Bearer ${localStorage.getItem('token')}`
      }
    });
  }
  
  async getConfig() {
    return await this.get(ENDPOINTS.CONFIG);
  }

  async getMarketTemplates() {
    return await this.get(ENDPOINTS.MARKET_TEMPLATES);
  }

  async save(newTranslation) {
    return await this.post(ENDPOINTS.CONFIG, newTranslation);
  }

  async post(url, data) {
    this.setHeaders()
    try {
      const response = await this.trendingAxiosClient.post(`${apiService.additionalUrls.trendingConfiguration}${url}`, data)

      return response
    } catch(error) {
      throw error
    }
  }

  async get(url, data) {
    this.setHeaders()
    try {
      const response = await this.trendingAxiosClient.get(`${apiService.additionalUrls.trendingConfiguration}${url}`, data)

      return response
    } catch(error) {
      throw error
    }
  }
}

export const trendingConfigurationService = new TrendingConfigurationService()
